import { Component, Input, OnInit, output, input, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { jkLib } from '../../services/jkCommon';
import { JkBaseComponent } from '../jkbase/jkbase.component';
import { JkfieldlabelComponent } from '../jkfieldlabel/jkfieldlabel.component';
import { CommonModule } from '@angular/common';
import { idNameItem } from '../../services/jkInterface';

/**
 * @description 按鈕群組元件，提供一組可切換的按鈕供使用者選擇
 * @class JkbuttongroupComponent
 * @extends {JkBaseComponent}
 * @implements {OnInit}
 */

@Component({
  selector: 'app-jkbuttongroup',
  standalone: true,
  imports: [//FormsModule, // 新增這行
    CommonModule,
    //BrowserAnimationsModule, // 新增這行
    JkfieldlabelComponent,
    MatButtonToggleModule, // 新增這行
    MatButtonModule ],
  templateUrl: './jkbuttongroup.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './jkbuttongroup.component.css'
})
export class JkbuttongroupComponent  extends JkBaseComponent implements OnInit {
  override comType: string = 'jkbuttongroup';
  override flexStyle:any = { display: 'flex'};
  readonly hideSingleSelectionIndicator = input<boolean>(true);
  readonly hideMultipleSelectionIndicator = input<boolean>(true);
  public readonly items = input<idNameItem[]>([]);
  _value: string = '';
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input()  set value(value:string){
    if(!value) return;
    this._value = value;

  }
  get value(){
    return this._value;
  }
  /*
  get itemIndex(): number{
    return this.items.findIndex(item => item.id === this._value);
  }
  set itemIndex(value: number){
    if(value >= 0 && value < this.items.length)
      this._value = this.items[value].id;
    else
      this._value = '';
  }
  get selectedItem(): idNameItem{
    if(this.itemIndex < 0)
      return {id:'',name:''}
    else
    return this.items[this.itemIndex];
  }
*/
  readonly valueChange = output<string>();
  //@Output() valueNChange = new EventEmitter<number>();
  onValueChange(newValue: string) {
    // debugger;
    /* if(this.value !== newValue) FIXME: 有時候 會不斷 loop
      this.value = newValue; */
    if(!newValue) return;
    if(this.valueChange)
      this.valueChange.emit(this.value);
  }
  constructor() {
    super();
   }
   override ngOnInit() {
    super.ngOnInit();
  }
  addWhere(where: string,fieldName:string,condition:string = '='): string {
    if(this.value){
      //where += ' AND ('+fieldName + ' = ' + jkLib.quotedStr(this.value)+') ';
      where = jkLib.text2Where(this.value, where, fieldName, condition);
    }
    return where;
  }

}
